import { delay } from 'redux-saga';
import { all, call, fork, put, select, spawn, take } from 'redux-saga/effects';
import { ADD, remove } from './actions';
import { getNotifications } from './selectors';

const EXPIRATION_TIME = 5000;

/* eslint-disable no-constant-condition */
export function* expire(id) {
  yield call(delay, EXPIRATION_TIME);
  yield put(remove(id));
}

export function* watchNotificationAdd() {
  while (true) {
    const { text, notificationType } = yield take(ADD);
    const notifications = yield select(getNotifications);

    const notification = notifications.find(n => n.text === text && n.type === notificationType);
    yield fork(expire, notification.get('id'));
  }
}

export default function* () {
  yield all([
    spawn(watchNotificationAdd)
  ]);
}
/* eslint-enable no-constant-condition */
